import { render, staticRenderFns } from "./ListOfProducts.vue?vue&type=template&id=1be074ab&scoped=true"
import script from "./ListOfProducts.vue?vue&type=script&lang=js"
export * from "./ListOfProducts.vue?vue&type=script&lang=js"
import style0 from "./ListOfProducts.vue?vue&type=style&index=0&id=1be074ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be074ab",
  null
  
)

export default component.exports